var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useRef } from "react";
// Material Ui
import { Box } from "@mui/material";
import Popover from "@mui/material/Popover";
import { createFilterOptions, } from "@mui/material/Autocomplete";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
// say lib
import ButtonV2 from "../../ButtonV2";
import Chip from "../../ChipV2";
import Text from "../../Text";
import { COLORS } from "../../../../constants";
// utils
import { getNextColor } from "./utils";
import { useScreenSize } from "../../../../hooks/useScreenSize";
import IconButton from "../../IconButton";
import { Add } from "@mui/icons-material";
import Autocomplete from "../Autocomplete";
var AutocompleteTagging = function (_a) {
    var 
    //title = "Filter By",
    _b = _a.canCreate, 
    //title = "Filter By",
    canCreate = _b === void 0 ? true : _b, options = _a.options, createNewValue = _a.createNewValue, onClose = _a.onClose, _c = _a.ctaTitle, ctaTitle = _c === void 0 ? "" : _c, value = _a.value, id = _a.id, _d = _a.testId, testId = _d === void 0 ? "" : _d, onChange = _a.onChange, scrollOnMobile = _a.scrollOnMobile, _e = _a.forceAutocompleteOpen, forceAutocompleteOpen = _e === void 0 ? false : _e, _f = _a.variant, variant = _f === void 0 ? "chip" : _f, _g = _a.asPopover, asPopover = _g === void 0 ? true : _g, newValue = _a.newValue, 
    //  displayOptionsAsChips = true,
    _h = _a.displaySelected, 
    //  displayOptionsAsChips = true,
    displaySelected = _h === void 0 ? true : _h, buttonProps = _a.buttonProps, iconButtonProps = _a.iconButtonProps, _j = _a.iconButtonIcon, iconButtonIcon = _j === void 0 ? _jsx(Add, {}) : _j, chipProps = _a.chipProps, chipClearable = _a.chipClearable, ctaCallback = _a.ctaCallback, _k = _a.multiple, multiple = _k === void 0 ? true : _k;
    var chipRef = useRef(null);
    var isMobile = useScreenSize().isMobile;
    var _l = __read(useState(null), 2), anchorEl = _l[0], setAnchorEl = _l[1];
    var _m = __read(useState(forceAutocompleteOpen), 2), autocompleteOpen = _m[0], setAutocompleteOpen = _m[1];
    var _o = __read(useState(options), 2), stateOptions = _o[0], setStateOptions = _o[1];
    var _p = __read(useState(multiple ? [] : null), 2), stateValue = _p[0], setValue = _p[1]; // array for multiselect single object for single select
    var _q = __read(useState("LIGHT_GREEN"), 2), nextColor = _q[0], setNextColor = _q[1];
    var open = Boolean(anchorEl);
    var filter = createFilterOptions();
    var selectedValue = value || stateValue;
    var allOptions = onChange ? options : stateOptions;
    var hasValue = !!(Array.isArray(selectedValue) && selectedValue.length) ||
        (!multiple && !!selectedValue);
    /**
     * update what the next color will be whenever the options change
     */
    useEffect(function () {
        setNextColor(getNextColor(allOptions));
    }, [options]);
    /**
     * Close autocomplete if non multi select and value changed to something other than null
     */
    useEffect(function () {
        if (!multiple && selectedValue !== null) {
            handleClose();
        }
    }, [selectedValue]);
    // blur chip on close
    useEffect(function () {
        var _a;
        if (!anchorEl) {
            (_a = chipRef === null || chipRef === void 0 ? void 0 : chipRef.current) === null || _a === void 0 ? void 0 : _a.blur();
        }
    }, [anchorEl, value]);
    /**
     * Only used if value state is managed by component
     * When a new tag value is passed in, update created new value
     * with the id generated by the api
     */
    useEffect(function () {
        if (!onChange && newValue) {
            // Only parse values if multi select otherwise just set the newValue
            if (Array.isArray(stateValue)) {
                var newValues = stateValue.map(function (itm) {
                    if (itm.name.toLowerCase() === newValue.name.toLowerCase()) {
                        return newValue;
                    }
                    return itm;
                });
                setValue(newValues);
            }
            else {
                setValue(newValue);
            }
            setStateOptions(options);
        }
    }, [newValue]);
    /**
     * change function for when a tag is selected
     */
    var handleChange = function (_, value_unknown, _reason, unknown_details) {
        var _a, _b, _c, _d;
        var details = unknown_details;
        var value = value_unknown;
        if (onChange) {
            onChange({
                allValues: multiple ? value : [],
                singleValue: multiple ? null : value,
                addedValue: details === null || details === void 0 ? void 0 : details.option,
            });
        }
        else {
            // uncontrolled variation needs to handle when a net new value is created
            // update options, update selected value with new and inputValue removed
            if ((_a = details === null || details === void 0 ? void 0 : details.option) === null || _a === void 0 ? void 0 : _a.new) {
                var adjustedValue_1 = {
                    name: (_b = details === null || details === void 0 ? void 0 : details.option) === null || _b === void 0 ? void 0 : _b.name,
                    color: (_c = details === null || details === void 0 ? void 0 : details.option) === null || _c === void 0 ? void 0 : _c.color,
                    id: (_d = details === null || details === void 0 ? void 0 : details.option) === null || _d === void 0 ? void 0 : _d.id,
                };
                // only parse values if multi select (use isArray for typescript checks)
                if (Array.isArray(value)) {
                    var updatedValues = value.map(function (val) {
                        if (val.id === adjustedValue_1.id) {
                            return adjustedValue_1;
                        }
                        return val;
                    });
                    setValue(updatedValues);
                }
                else {
                    setValue(adjustedValue_1);
                }
                setStateOptions(__spreadArray(__spreadArray([], __read(stateOptions), false), [adjustedValue_1], false));
                if (createNewValue) {
                    createNewValue(adjustedValue_1);
                }
            }
            else {
                setValue(value);
            }
        }
    };
    /**
     * force close menu
     */
    var handleClose = function () {
        if (onClose) {
            onClose(selectedValue);
        }
        setAutocompleteOpen(false);
        setAnchorEl(null);
    };
    /**
     * set anchor element for popover positioning to the chip
     */
    var handleCtaClick = function (event) {
        var currentTarget = event.currentTarget;
        if (ctaCallback) {
            ctaCallback(event);
        }
        if (scrollOnMobile && isMobile) {
            currentTarget.scrollIntoView();
            setTimeout(function () {
                setAnchorEl(currentTarget);
            }, 100);
        }
        else {
            setAnchorEl(currentTarget);
        }
    };
    /**
     * if not clearable or no value - set anchor element for popover positioning to the chip (parent of delete icon)
     * run passed in delete function on click
     */
    var handleCtaDeleteClick = function (event) {
        if (chipProps === null || chipProps === void 0 ? void 0 : chipProps.onDelete) {
            chipProps === null || chipProps === void 0 ? void 0 : chipProps.onDelete(event);
        }
        if (!hasValue || !chipClearable) {
            setAnchorEl(event.currentTarget.parentElement);
        }
    };
    /**
     * add option to create if tag doesnt exist
     */
    var filterOptions = function (optionsToFilter, state) {
        var filtered = filter(optionsToFilter, state);
        var inputValue = state.inputValue;
        // Suggest the creation of a new value
        var isExisting = allOptions.some(function (option) {
            return inputValue.toLowerCase() === option.name.toLowerCase();
        });
        if (inputValue !== "" && !isExisting) {
            filtered.push({
                name: inputValue,
                color: nextColor,
                new: true,
                id: onChange ? -2 : 8000 + stateOptions.length,
                inputValue: inputValue,
            });
        }
        return filtered;
    };
    /**
     * renders auto complete component
     */
    var renderAutoComplete = function () { return (_jsx(Autocomplete, { multiple: multiple, disableClearable: multiple ? true : false, id: id || "autocomplete-standard", popupIcon: null, inline: true, value: selectedValue, open: !asPopover || autocompleteOpen, noOptionsText: _jsx(Text, __assign({ variant: "body2", emphasis: "medium_low" }, { children: "No options" })), displaySelected: displaySelected, onChange: handleChange, options: allOptions, getOptionLabel: function (option) { return option.name; }, isOptionEqualToValue: function (option, value) { return option.id === value.id || !!value.new; }, filterOptions: canCreate ? filterOptions : undefined })); };
    /**
     * wraps auto complete in popover
     */
    var renderAsPopover = function () { return (_jsx(Popover, __assign({ id: "demo-positioned-menu", "aria-labelledby": "demo-positioned-button", anchorEl: anchorEl, disableEnforceFocus: true, disableRestoreFocus: true, disableAutoFocus: true, open: open, onClose: handleClose, sx: {
            ".MuiPaper-root": {
                minWidth: "300px",
            },
        }, anchorOrigin: {
            vertical: "bottom",
            horizontal: "left",
        }, transformOrigin: {
            vertical: "top",
            horizontal: "left",
        }, 
        // doesnt run in jest
        /* istanbul ignore next */
        onTransitionEnd: function () { return setAutocompleteOpen(open); } }, { children: renderAutoComplete() }))); };
    /**
     * Label to display in chip when autocomplete is closed
     */
    var getChipLabel = function () {
        if (Array.isArray(selectedValue)) {
            var suffix = selectedValue.length ? " (".concat(selectedValue.length, ")") : ""; // only show suffix if value is an array
            return "".concat(ctaTitle).concat(suffix);
        }
        return selectedValue ? selectedValue.name : ctaTitle;
    };
    /**
     * Render button or chip to trigger autocomplete
     */
    var renderCTA = function () {
        switch (variant) {
            case "iconButton":
                return (_jsx(IconButton, __assign({ "data-testid": "trigger-autocomplete-iconButton", onClick: handleCtaClick }, iconButtonProps, { children: iconButtonIcon })));
            case "button":
                return (_jsx(ButtonV2, __assign({ variant: "text", "data-testid": "trigger-autocomplete-button", onClick: handleCtaClick }, buttonProps, { children: ctaTitle })));
            case "chip":
                return (_jsx(Chip, __assign({}, chipProps, { deleteIcon: !value ||
                        !chipClearable ||
                        (multiple && !(value === null || value === void 0 ? void 0 : value.length)) ? (_jsx(ArrowDropDownIcon, { style: { color: COLORS.BLACK } })) : undefined, ref: chipRef, selected: hasValue || !!open, onClick: handleCtaClick, onDelete: handleCtaDeleteClick, "data-testid": "trigger-autocomplete-chip", label: getChipLabel() })));
            default:
                return null;
        }
    };
    return (_jsxs(Box, __assign({ "data-testid": testId }, { children: [renderCTA(), asPopover ? renderAsPopover() : renderAutoComplete()] })));
};
export default AutocompleteTagging;
